import axios from 'axios'
import library from '../../../utils/Library'

export const enableAdminUserMERegistration = async (userId) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('miestudio_user_registration') +
    '/enableAdminUserMERegistration'

  return await axios({
    url: URL,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    data: { userId }
  })
}
